import React from 'react';
import Time from '../../images/time.png';
import Calender from '../../images/calender.png';

const Row = ({ no, src, name, phone, date, time, conSrc }) => {
    return <tr className="cus_hr">
      <td style={{ width: "100px", fontWeight: 'bold' }}>{no}</td>
      <td>
        <div className="row">
          <img src={src} alt="img" className="mr-3" />
          <div className="text-left" style={{lineHeight: "20px"}}>
            <div className="cus_strng">{name}</div>
            <div className="cus_sp">{phone}</div>
          </div>
        </div>
      </td>
      <td className="cus_date">{date}</td>
      <td className="cus_time">{time}</td>
      <td>
        <center><img src={conSrc} alt="img" /></center>
      </td>
      <td><button className="tableButton mr-2">CANCEL</button>
        <button className="tableButton active">APPROVE</button></td>
    </tr>
  }
  
  const MobRow = ({ no, src, name, phone, date, time, conSrc }) => {
    return <div className="cus_hr">
  
      <div className="col-lg-12 d-flex justify-content-between">
        <div className="row ">
          <img className="mr-3" src={src} alt="img" />
          <div className="text-left" style={{lineHeight: "20px"}}>
            <div className="cus_strng">{name}</div>
            <div className="cus_sp">{phone}</div>
          </div>
        </div>
        <img src={conSrc} alt="icon" />
      </div>
  
      <div className="row col_row">
        <div className="col-lg-12 d-flex justify-content-between">
          <div className="cus_date"> <img src={Calender} alt="icon" /> {date}</div>
          <div className="cus_time"> <img src={Time} alt="icon" /> {time}</div>
        </div>
      </div>
      <div className="row  col_row">
        <div className="col-lg-12 tableButtons">
          <button className="tableButton">CANCEL</button>
          <button className="tableButton active">APPROVE</button>
        </div>
      </div>
  
    </div>
  }
export {Row, MobRow}  